import React from "react";
import { Breadcrumbs, Tabs, Tab, Typography, Box } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Div from "@jumbo/shared/Div";

const PriceCalculatorLayout = ({ children }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const isTypes = location.pathname.includes("/price-calculator/type-table");
  const tabValue = isTypes ? "licenseTypes" : "calculator";

  const handleTabChange = (e, val) => {
    if (val === "calculator") navigate("/price-calculator");
    if (val === "licenseTypes") navigate("/price-calculator/type-table");
  };

  return (
    <React.Fragment>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
          mb: 2,
          whiteSpace: "nowrap",
          "& .MuiBreadcrumbs-ol": { flexWrap: "nowrap" },
        }}
      >
        <Link to="/">{t("sidebar.menuItem.home")}</Link>
        <Typography
          component="span"
          sx={{ display: "inline" }}
          color="text.primary"
        >
          {t("sidebar.menuItem.priceCalculator")}
        </Typography>
      </Breadcrumbs>
      <Div>
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="price calculator tabs"
          >
            <Tab
              label={t("sidebar.menuItem.priceCalculator", {
                defaultValue: "Price Calculator",
              })}
              value="calculator"
            />
            <Tab
              label={t("pages.priceCalculator.types", {
                defaultValue: "Typy licencií",
              })}
              value="licenseTypes"
            />
          </Tabs>
        </Box>
        {children}
      </Div>
    </React.Fragment>
  );
};

export default PriceCalculatorLayout;
